/**
 * Register debounce when page is hidden, navigated from etc
 * Actual beforeunload event may not be triggered in some scenarios
 */
export function beforeunload(
    callback: () => any,
    options: AddEventListenerOptions = {},
) {
    document.addEventListener(
        "visibilitychange",
        () => document.visibilityState === "hidden" && callback(),
        options,
    );
    document.addEventListener("pagehide", callback, options); // Safari
}
